import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {WhatsHappeningComponent} from "./whats-happening.component";
import {EventCalendarComponent} from "./event-calendar/event-calendar.component";

const routes: Routes = [
    { path: 'upcoming-events', component: WhatsHappeningComponent, data: { title: 'Upcoming Events' } },
    { path: 'announcements', component: WhatsHappeningComponent, data: { title: 'Announcements' } },
    { path: 'news', component: WhatsHappeningComponent, data: { title: 'News' } },
    { path: 'media-coverage', component: WhatsHappeningComponent, data: { title: 'Media Coverage' } },
    { path: 'fm-radio', component: WhatsHappeningComponent, data: { title: 'FM Radio Suno AARNI 90.8FM' } },
    {
        path: 'event-calendar',
        component: EventCalendarComponent
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WhatsHappeningRoutingModule { }
